/**
 * Whether `url` uses the http/https scheme.
 *
 * Guards links rendered from API-provided URLs (e.g. shipment tracking links)
 * against a `javascript:`/`data:` URL being used as an XSS vector.
 */
export function isHttpUrl(url: string): boolean {
  try {
    return ['http:', 'https:'].includes(new URL(url).protocol);
  } catch {
    return false;
  }
}

/**
 * Returns `redirect` only when it is a safe same-origin path, otherwise `undefined`.
 *
 * Blocks open-redirect vectors: protocol-relative URLs (`//evil.com`),
 * backslash-based bypasses (`\\evil.com`), and scheme injections (`javascript:`, `data:`).
 */
export function getSafeRedirect(redirect?: string): string | undefined {
  if (
    redirect &&
    redirect.startsWith('/') &&
    !redirect.startsWith('//') &&
    !redirect.includes('\\') &&
    !/\p{Cc}/u.test(redirect) &&
    !redirect.includes(':')
  ) {
    return redirect;
  }
  return undefined;
}
